import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './LiveSchedule.css';

const LiveSchedule = ({ userData }) => {
  const [currentWeekOffset, setCurrentWeekOffset] = useState(0);
  const [scheduleData, setScheduleData] = useState({ weeks: [] });
  const [isLoading, setIsLoading] = useState(true);

  // Function to get week start and end dates
  const getWeekDates = (weekOffset) => {
    const now = new Date();
    const currentDay = now.getDay();
    const currentDate = now.getDate();
    
    const startDate = new Date(now);
    startDate.setDate(currentDate - (currentDay === 0 ? 6 : currentDay - 1) + (weekOffset * 7));
    
    const endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + 6);
    
    return { startDate, endDate };
  };

  const { startDate, endDate } = getWeekDates(currentWeekOffset);

  // Format date as "Mon 28-Apr"
  const formatDayHeader = (date) => {
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    
    const dayName = days[date.getDay()];
    const dayNum = date.getDate();
    const monthName = months[date.getMonth()];
    
    return `${dayName} ${dayNum}-${monthName}`;
  };

  // Generate dates for the current week
  const generateWeekDates = () => {
    const dates = [];
    const current = new Date(startDate);
    
    while (current <= endDate) {
      dates.push(new Date(current));
      current.setDate(current.getDate() + 1);
    }
    
    return dates;
  };
  const isToday = (date) => {
    const today = new Date();
    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  };
  const weekDates = generateWeekDates();

  // Time slots with half-hour increments in the afternoon
  const generateTimeSlots = () => {
    const slots = [];
    // Morning slots (full hours)
    for (let hour = 8; hour < 12; hour++) {
      slots.push(`${hour}:00 AM`);
    }
    // 1:00 PM
    slots.push('12:00 PM');
    slots.push('1:00 PM');
    
    // Afternoon slots (half-hour increments)
    for (let hour = 2; hour <= 10; hour++) {
      slots.push(`${hour}:00 PM`);
      
    }
    return slots;
  };
  const generateTimeSlots1 = () => {
    const slots = [];
    // Morning slots (full hours)
    for (let hour = 8; hour < 12; hour++) {
      slots.push(`${hour}:00 AM`);
    }
    // 1:00 PM
    slots.push('12:00 PM');
    slots.push('1:00 PM');
    // Afternoon slots (half-hour increments)
    for (let hour = 2; hour <= 10; hour++) {
      slots.push(`${hour}:30 PM`);
      
    }
    return slots;
  };
  const timeSlots = generateTimeSlots();
  const timeSlots1 = generateTimeSlots1();

  // Calculate end time based on start time (1 hour sessions)
  const getEndTime = (startTime) => {
    const [time, period] = startTime.split(' ');
    let [hours, minutes] = time.split(':').map(Number);
    
    if (period === 'PM' && hours !== 12) hours += 12;
    if (period === 'AM' && hours === 12) hours = 0;
    
    const endDate = new Date(0, 0, 0, hours, minutes);
    endDate.setHours(endDate.getHours() + 1);
    
    let endHours = endDate.getHours();
    const endPeriod = endHours >= 12 ? 'PM' : 'AM';
    endHours = endHours % 12 || 12;
    const endMinutes = endDate.getMinutes().toString().padStart(2, '0');
    
    return `${endHours}:${endMinutes} ${endPeriod}`;
  };

  // Find the correct time slot for a given time
  const findTimeSlot = (timeStr) => {
    const [time, period] = timeStr.split(' ');
    let [hours, minutes] = time.split(':').map(Number);
    
   
    
   
      return `${hours % 12 || 12}:00 ${period}`;
    
  };
  
 
  // Fetch schedule data from API
  useEffect(() => {
    const fetchScheduleData = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/teacher/liveschedule/${userData.id}/${currentWeekOffset}`
        );
        
        // Transform API data into our format
        const transformedData = transformApiData(response.data.results);
        setScheduleData({ weeks: [transformedData] });
      } catch (error) {
        console.error('Error fetching schedule:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchScheduleData();
  }, [currentWeekOffset, userData.id]);

  // Transform API data to our format
  const transformApiData = (apiResults) => {
    const weekData = {
      days: {
        monday: [],
        tuesday: [],
        wednesday: [],
        thursday: [],
        friday: [],
        saturday: [],
        sunday: []
      }
    };

    apiResults.forEach(session => {
      const date = new Date(session.ClassDateTime);
      const dayName = date.toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      let timeString;
      
      // Convert to AM/PM format
      if (hours === 0) {
        timeString = `12:${minutes.toString().padStart(2, '0')} AM`;
      } else if (hours < 12) {
        timeString = `${hours}:${minutes.toString().padStart(2, '0')} AM`;
      } else if (hours === 12) {
        timeString = `12:${minutes.toString().padStart(2, '0')} PM`;
      } else {
        timeString = `${hours - 12}:${minutes.toString().padStart(2, '0')} PM`;
      }

      // Find the correct time slot
      const slotTime = findTimeSlot(timeString);

      // Extract first and last name
      const nameParts = session.FullName.split('.');
      const firstName = nameParts[0].trim();
      const lastName = nameParts[1] ? nameParts[1].trim().charAt(0) : '';

      const sessionObj = {
        time: slotTime,
        timeview: slotTime,
        actualTime: timeString,
        type: session.Type === 0 ? 'paid' : session.Type === 1 ? 'demo' : 'group',
        sessionsTaken: session.sessionsTaken,
        totalSessions: session.totalSessions
      };

      if (session.Type === 2) {
        sessionObj.groupName = `Group ${session.FullName.split(' ')[1]}`;
      } else {
        sessionObj.student = {
          firstName,
          lastName
        };
      }

      weekData.days[dayName].push(sessionObj);
    });

    return weekData;
  };

  const handlePrevWeek = () => {
    setCurrentWeekOffset(currentWeekOffset - 1);
  };

  const handleNextWeek = () => {
    setCurrentWeekOffset(currentWeekOffset + 1);
  };

  // Format date range for display
  const formatDateRange = (start, end) => {
    const options = { day: 'numeric', month: 'short' };
    return `${start.toLocaleDateString('en-US', options)} - ${end.toLocaleDateString('en-US', options)}`;
  };

  // Get session count color based on progress
  const getSessionCountColor = (taken, total) => {
    if (taken === total) return 'red';
    if (taken === total - 1) return 'orange';
    return 'inherit';
  };

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading schedule...</p>
      </div>
    );
  }

  return (
    <div className="live-schedule">
        <div className="table-header">
          <button onClick={handlePrevWeek} className="nav-button">
            &lt;
          </button>
          <h3>{formatDateRange(startDate, endDate)}</h3>
          <button onClick={handleNextWeek} className="nav-button">
            &gt;
          </button>
        </div>
      <div className="schedule-table">
        

        <div className="table-body">
          <div className="time-column">
            <div className="time-header">Time</div>
            {timeSlots1.map(time => (
              <div key={time} className={`time-slot-label ${time==="1:00 PM"?'bigger':''}`}>{time}</div>
            ))}
          </div>

          <div className="days-container">
          <div className="days-header">
            {weekDates.map(date => (
              <div key={date} className="day-header">
                {formatDayHeader(date)}
                {isToday(date) && <div className="today-badge">Today</div>}
              </div>
            ))}
          </div>

            <div className="schedule-grid">
              {timeSlots.map(time => (
                <div key={time} className="time-row">
                  {weekDates.map(date => {
                    const dayName = date.toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase();
                    const sessions = scheduleData.weeks[0]?.days[dayName] || [];
                    const sessionAtThisTime = sessions.filter(s => s.time === time);
                    return (
                      <div key={`${dayName}-${time}`} className={`time-slot ${time==="1:00 PM"?'bigger':''}`}>
                         {sessionAtThisTime.map((session, index) => (
                          

                          <div 
                          className={`session ${session.type}`}
                          
                          style={{
                            top: (() => {
                              // Calculate pixel offset based on time difference
                              const [slotTime, slotPeriod] = time.split(' ');
                              let [slotHour, slotMinute] = slotTime.split(':').map(Number);
                              
                              if (slotPeriod === 'PM' && slotHour !== 12) slotHour += 12;
                              if (slotPeriod === 'AM' && slotHour === 12) slotHour = 0;
                              if (slotHour >=14) slotMinute=30;
                              const [actualTime, actualPeriod] = session.actualTime.split(' ');
                              let [actualHour, actualMinute] = actualTime.split(':').map(Number);
                              if (actualPeriod === 'PM' && actualHour !== 12) actualHour += 12;
                              if (actualPeriod === 'AM' && actualHour === 12) actualHour = 0;
                              
                              const diffMinutes = (actualHour * 60 + actualMinute) - (slotHour * 60 + slotMinute);
                              // 1 minute = 1px (adjust as needed)
                              return `${diffMinutes}px`;
                            })()
                          }}
                          
                          >
                            {session.type === 'group' ? (
                              <div className="group-name">{session.groupName}</div>
                            ) : (
                              <div className="student-name">
                                {session.student.firstName} {session.student.lastName}
                              </div>
                            )}
                            <div
                              className={`session-time `}>
                              {session.actualTime}
                            </div>
                            {session.type === 'demo' ? (
                              <div className="demo-text">Demo</div>
                            ) : (
                              <div 
                                className="session-count"
                                style={{ color: getSessionCountColor(session.sessionsTaken, session.totalSessions) }}
                              >
                                {session.sessionsTaken}/{session.totalSessions}
                              </div>
                            )}
                          </div>
                      ))}
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiveSchedule;